import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from "immutable";
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";

import TextInputField from '../../infra/components/formInput/CustomTextInput' 
import ComboboxInput from '../../infra/components/formInput/ComboboxInput'
import {IsEdit, IsCreate, IsView } from '../../store/constants'
import ActionAdd from '../../store/action/Account/Add'  
import ActionGetClient from '../../store/action/Client/FetchAll'
import ActionGetDivision from '../../store/action/Division/FetchAll'
import ActionGetPrevilage from '../../store/action/Previlage/FetchAll'
//import ActionGetAllSender from "../../store/action/Sender/FetchAll";
import ActionGetAllSender from '../../store/action/Sender/FetchAll'


class Form extends Component{

  constructor(props){
    super(props);
    this.state ={
      form : fromJS({
        'username':'',
        'password' : '',
        'client-id':'',
        'division-id':'',
        'division-name':'',
        'full-name':'',
        'privilege-id':'',
        'sender-id'     : '',
      }),
      loadded: false,
      disabled: false,
      errors: fromJS({}),
      error: '',
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  handleChange(field, value) {
    if(value == null){
        // eslint-disable-next-line no-restricted-globals
        value = event.target.value;
    }
    var formVal = this.state.form;
    formVal = formVal.set(field,value); 
    this.setState({ form:formVal })
    if(field === "client-id"){
      this.props.actionGetDivision(value);
      this.props.actionGetAllSender(value);
    }
  }
  async handleSubmit(dispatch) {

    const form = this.state.form;
    if(form.get('username') === ''){
        this.setState({error : "username cannot be empty!"});
    }else{

      switch(this.props.actionType) {
        case IsCreate:
            await this.SubmitNewData();
          break;
        case IsEdit:
            await this.SubmitEditData();
          break;
        default:
          // code block
      }  

    }
  }

  async SubmitNewData(){
    const form = this.state.form;
    var data =  
        {'data' : 
            {
                'username': form.get('username'),
                'password': form.get('password'),
                'client-id': form.get('client-id'),
                'division-id': form.get('division-id'),
                'full-name': form.get('full-name'),
                'privilege-id': form.get('privilege-id'),
                'sender-id': form.get('sender-id'),
            }
        };
//tutup dulu
        var response = await this.props.actionAdd(data);
        if(response.ok){
          toast.success('Save Success!', toast.POSITION.TOP_RIGHT);
          this.props.handleCancelForm(true);
        }else{
          //toast.error('Save Failed', toast.POSITION.TOP_RIGHT);
        }
  }

  async SubmitEditData(){
  }

  handleCancel(){
    this.props.handleCancelForm(false);  
  }

  componentDidMount(){
    this.props.actionGetClient();
    if(this.state.form.get('client-id') !== undefined && this.state.form.get('client-id') !== ''){
      this.props.actionGetDivision(this.state.form.get('client-id'));
      this.props.actionGetAllSender(this.state.form.get('client-id'));
    }
    this.props.actionGetPrevilage();
  }

  componentWillMount(){
    if(this.props.item != null || this.props.item !== undefined){
      if((this.props.actionType === IsView || this.props.actionType === IsEdit) && !this.state.loadded){
        this.setState({
          form:  fromJS(this.props.item),
          loadded: true,
          disabled: (this.props.actionType === IsView),
        })  
      }
    }
  }

  render(){
    const { form, errors, disabled } = this.state;
    const { clientall } = this.props

    const clients = []

    if(clientall != null){
      clientall.map((item) => {
        clients.push({label: item.get('client-name'), value: item.get('client-id')})
      })
    }

    let btnSubmit = <button type="button"
                      className="btn btn-wide btn-success"
                      onClick={ this.handleSubmit }>
                        Submit
                  </button>
    if(this.props.actionType === IsView){
      btnSubmit = ''
    }
    
    return (
      <div className="card no-margin-bottom">
      <div className="body">
        <div className="row no-margin-bottom">
              <span className="col-sm-2">Username</span>
              <div className="col-sm-10">
                  <TextInputField className="form-control"
                      field={'username'}
                      value={ form.get('username')}
                      onChange={(field, value) => this.handleChange(field,value)}
                      placeholder="username"  
                      disabled={ disabled }
                      hasError={errors.has('username')}
                  />
              </div>
          </div>

          <div className="row no-margin-bottom">
              <span className="col-sm-2">Password</span>
              <div className="col-sm-10">
                  <TextInputField className="form-control"
                      field={'password'}
                      password
                      value={ form.get('password') }
                      onChange={(field, value) => this.handleChange(field,value)}
                      placeholder="password"  
                      disabled={ disabled }
                      hasError={errors.has('password')}
                  />
              </div>
          </div>

          <div className="row no-margin-bottom">
              <span className="col-sm-2">Client</span>
              <div className="col-sm-10">
                <ComboboxInput
                    field='client-id'
                    value={form.get('client-id')}
                    options={fromJS({
                        'source': this.props.clientall,
                        'value': 'client-id',
                        'label': 'client-name'
                    }) }
                    onChange={(field, value) => this.handleChange(field,value)}
                    placeholder="Client"
                    disabled={this.state.disabled}
                />  
              </div>
          </div>

          
          <div className="row no-margin-bottom">
              <span className="col-sm-2">Division</span>
              <div className="col-sm-10">
              <ComboboxInput
                    field='division-id'
                    value={form.get('division-id')}
                    options={fromJS({
                        'source': this.props.divisionall,
                        'value': 'division-id',
                        'label': 'division-name'
                    }) }
                    onChange={(field, value) => this.handleChange(field,value)}
                    placeholder="Division"
                    disabled={this.state.disabled}
                />  
              </div>
          </div>

          <div className="row no-margin-bottom">
              <span className="col-sm-2">Sender</span>
              <div className="col-sm-10">
                  <ComboboxInput
                      field='sender-id'
                      value={form.get('sender-id')}
                      options={fromJS({
                          'source': this.props.senderall,
                          'value': 'sender-id',
                          'label': 'sender-name'
                      }) }
                      onChange={(field, value) => this.handleChange(field,value)}
                      placeholder="Sender"
                      disabled={this.state.disabled}
                  />
              </div>
          </div>

          <div className="row no-margin-bottom">
              <span className="col-sm-2">Full Name</span>
              <div className="col-sm-10">
                  <TextInputField className="form-control"
                      field={'full-name'}
                      value={ form.get('full-name')}
                      onChange={(field, value) => this.handleChange(field,value)}
                      placeholder="fullname"  
                      disabled={ disabled }
                      hasError={errors.has('fullname')}
                  />
              </div>
          </div>  

          <div className="row no-margin-bottom">
              <span className="col-sm-2">Previlege</span>
              <div className="col-sm-10">
                <ComboboxInput
                    field='privilege-id'
                    value={form.get('privilege-id')}
                    options={ fromJS({
                        'source': this.props.previlagesall,
                        'value': 'privilege-id',
                        'label': 'privilege-name'
                    }) }
                    onChange={(field, value) => this.handleChange(field,value)}
                    placeholder="Previlage"
                    disabled={this.state.disabled}
                />
              </div>
          </div>

          <div className="row no-margin-bottom">
            <span className="col-sm-2"></span>
            <div className="col-sm-10">
            <button type="button"
                  className="btn btn-wide btn-success"
                  value="Cancel"
                  onClick={ this.handleCancel }>
                    Back to list
              </button>
              {btnSubmit}
            </div>
          </div>
        </div>
        </div>
    );
  }
}


export default connect(
  (state) => {
      return {
          clientall: state.user.clientall,
          divisionall: state.user.divisionall,
          senderall: state.user.senders,
          previlagesall: state.user.previlagesall
      }
  },
  dispatch => bindActionCreators({
      actionAdd: ActionAdd,
      actionGetClient: ActionGetClient,
      actionGetDivision: ActionGetDivision,
      actionGetPrevilage:ActionGetPrevilage,
      actionGetAllSender: ActionGetAllSender,
  }, dispatch),
)(Form);